<template>
    <div class="card">
        <div class="card-header">Device - {{ device.hash }}</div>

        <div class="card-body">
            <statistics-chart :device="device" :legend="legend" />
        </div>
    </div>
</template>

<script>
import StatisticsChart from './chart/StatisticsChart.vue';

export default {
  props: ['device', 'fields', 'legend'],

  components: {
    StatisticsChart,
  },
};
</script>
